import env from '@y2/environments';

export const assetsBasePath = `${env.assets.basePath}/y2_frontend/apps/yad1/`;

export const IMAGE_FALLBACK = `${env.assets.basePath}/common/logo-yad1.svg`;
